import Vue from "vue";
import Vuex from "vuex";
import packet from "./module/packet";
import sdkhb from "./module/sdkhb";
import kshb from "./module/kshb";
import recall from "./module/recall";
import gamejump from "./module/gameJump";
import accountCancel from "./module/accountCancel";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    packet,
    sdkhb,
    kshb,
    recall,
    gamejump,
    accountCancel,
  },
});
